module.exports = "/_next/static/images/airbnb-avatar-b7403ed0d9e1f71c4dfd1df244e98d5c.png";